import React from 'react';
import { Grid } from '@mui/material';
import { Page } from '../components/Page';
import { CardLink } from '../components/CardLink';

export default function Dashboard() {
  return (
    <Page>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <CardLink to="/balances" title="Balances" description="View OpenRouter API credit balances." />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <CardLink to="/attendance" title="Attendance" description="Keka check-in / check-out and crons." />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <CardLink to="/matrimony" title="Matrimony" description="Profiles, bio data, and status tracking." />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <CardLink to="/finances" title="Finances" description="Income, expenses, cash flow, and balance by month." />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <CardLink to="/health" title="Health" description="Medical cases, reports, prescriptions, and documents." />
        </Grid>
      </Grid>
    </Page>
  );
}
